import { gql } from 'apollo-boost';
import {STUDENT_NAME_FIELDS, TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_LATEST_MESSAGE_ALL_CHANNELS = gql`
  query getLatestMessageAllChannels(
    $uuid: String
    $id: ID,
    $code: String
  ) {
    getLatestMessageAllChannels (
      uuid: $uuid
      id: $id
      code: $code
    ){
      timestamp
      chat {
        id
      }
      pm {
        id
        checksum
        toUserCode
        toUser { id uuid code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUserCode
        fromUser { id uuid code nameLocal surnameLocal nameEng surnameEng email photo }
        topic
        message
        sendDate
        hasNewReply
        newReplyDate
        readDate
        courseOutlineRegistration {
          subject {
            id
          }
          subjectCode
          subjectName
        }
        classSection {
          id
        }
        privateMessageReplies {
          id
          toUserCode fromUserCode message sendDate isRead readDate
          isFromTeacher isFromStudent
        }
        updatedAt
        updatedBy { id }
      }
      webboard {
        id sectionNo periodCode teacherCode studentCode
        topic topicDetail picturePath

        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }

        webBoardReplies {
          id teacherCode studentCode
          replyMessage picturePath email updatedAt

          teacher {
            ...TeacherNameFields
            picturePath
          }
          student {
            ...StudentNameFields
            picturePath
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_RECENT_MESSAGE_LIST = gql`
  query getRecentMessageList(
    $uuid: String
    $id: ID,
    $code: String
  ) {
    getRecentMessageList (
      uuid: $uuid
      id: $id
      code: $code
    ){
      timestamp
      chat {
        id
      }
      pm {
        id
        sendDate
        updatedAt
        privateMessageReplies {
          id
          toUserCode fromUserCode message sendDate isRead readDate
          isFromTeacher isFromStudent
        }
      }
      webboard {
        id
        updatedAt
      }
    }
  }
`;

export const GET_MESSAGE_TOPICS_BY_IDS = gql`
  query getMessageTopicsByIds(
    $uuid: String
    $id: ID
    $code: String
    $list: [CommonMessageTopicForm]
    $channel: String
  ) {
    getMessageTopicsByIds (
      uuid: $uuid
      id: $id
      code: $code
      list: $list
      channel: $channel
    ){
      timestamp
      chat {
        id
      }
      pm {
        id
        checksum
        toUserCode
        toUser {
          id uuid code nameLocal surnameLocal nameEng surnameEng email photo
        }
        fromUserCode
        fromUser {
          id uuid code nameLocal surnameLocal nameEng surnameEng email photo
        }
        topic
        message
        sendDate
        hasNewReply
        newReplyDate
        readDate
        courseOutlineRegistration {
          subject {
            id
          }
          subjectCode
          subjectName
        }
        classSection {
          id
        }
        privateMessageReplies {
          id
          sendDate
          toUserCode fromUserCode message isRead readDate
          isFromTeacher isFromStudent
        }
        updatedAt
        updatedBy { id }
      }
      webboard {
        id sectionNo periodCode teacherCode studentCode
        topic topicDetail picturePath

        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }

        webBoardReplies {
          id teacherCode studentCode
          replyMessage picturePath email updatedAt

          teacher {
            ...TeacherNameFields
            picturePath
          }
          student {
            ...StudentNameFields
            picturePath
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_MESSAGES_BY_IDS = gql`
  query getMessagesByIds(
    $uuid: String
    $id: ID
    $code: String
    $list: [CommonMessageForm]
    $channel: String
  ) {
    getMessagesByIds (
      uuid: $uuid
      id: $id
      code: $code
      list: $list
      channel: $channel
    ){
      timestamp
      chat {
        id
      }
      pm {
        id
        sendDate
        toUserCode fromUserCode 
        message
        readDate
        isFromTeacher
        isFromStudent
      }
      webboard {
        id
      }
    }
  }
`;

export const CHECK_COMMUNICATION_UPDATE = gql`
  query checkCommunicationUpdate(
    $uuid: String
    $user_id: ID
    $code: String
    $channel: String
    $type: String
    $id: ID
    $checksum: String
  ) {
    checkCommunicationUpdate (
      uuid: $uuid
      user_id: $user_id
      code: $code
      channel: $channel
      type: $type
      id: $id
      checksum: $checksum
    ){
      timestamp
      chat {
        id
      }
      pm {
        id
        checksum
        toUserCode
        toUser {
          id uuid code nameLocal surnameLocal nameEng surnameEng email photo
        }
        fromUserCode
        fromUser {
          id uuid code nameLocal surnameLocal nameEng surnameEng email photo
        }
        topic
        message
        sendDate
        hasNewReply
        newReplyDate
        readDate
        courseOutlineRegistration {
          subject {
            id
          }
          subjectCode
          subjectName
        }
        classSection {
          id
        }
        privateMessageReplies {
          id
          sendDate
          toUserCode fromUserCode message isRead readDate
          isFromTeacher isFromStudent
        }
        updatedAt
        updatedBy { id }
      }
      webboard {
        id
      }
    }
  }
`;
